import { useEffect, useState } from 'react';
import { MdModeEditOutline, MdDelete } from 'react-icons/md';
import { ref, getDownloadURL } from 'firebase/storage';
import EditRecommend from './Editor/EditRecommend';
import noPicture from './Editor/images/no_picture.jpg';

const Recommend = (props) => {
    const [background, setBackground] = useState("");

    const remove = (e) => {
        e.stopPropagation();
        props.callback.showPopup('Eliminar', <EditRecommend id={props.id} recommend={props.data} restaurantList={props.restaurantList} resID={props.resID} picture={background} setPicture={setBackground} eDB={props.eDB} storage={props.storage} close={props.callback.closePopup} delete/>);
    }

    const edit =(e) => {
        e.stopPropagation();
        props.callback.showPopup('Editar', <EditRecommend id={props.id} recommend={props.data} restaurantList={props.restaurantList} resID={props.resID} picture={background} setPicture={setBackground} eDB={props.eDB} storage={props.storage} close={props.callback.closePopup}/>);
    }

    const open = () => {
        if(!props.preview){
            props.callback.open(props.id, props.data);
        }
    }

    useEffect(() => {
        // Get Current Front
        const pictureRef = ref(props.storage, `Recommendations/${props.id}/${props.data.picture}`);
        
        getDownloadURL(pictureRef).then((url) => {
            setBackground(url);
        }).catch((_) => {
            console.log("Unable to get the photoURL");
        });      
    }, [props.data, props.id, props.data.picture, props.storage]);
    
    return (
        <div className="Recommend" onClick={(e) => open()}>
            <div style={{overflow: 'hidden', textAlign: 'center', maxHeight: '410px'}} >
                <img src={background?background:noPicture} width='100%' alt={props.data.name}/>
            </div>

            <div className='RecommendGradient'></div>

            <div style={{display: props.preview ? 'none':'flex'}} className='EditTools'>
                <button onClick={(e) => {edit(e);}} className="cbtn"><MdModeEditOutline size='1rem' pointerEvents='none'/></button>
                <button onClick={(e) => remove(e)} className="cbtn ml-1"><MdDelete size='1rem' pointerEvents='none' /></button>
            </div>

            <div className="Info">
                <div className="d-flex d-col-dir m-auto">
                    <div className="Name m-auto tx-white"><strong>{props.data.title}</strong></div>
                    <div className="Legend m-auto tx-red">{props.data.legend}</div>
                </div>
            </div>            
        </div>
    );
}

export default Recommend;